<p>
  add-doc-dialog works!
</p>
